import { TextField } from "@mui/material";
import React from "react";
import ReorderableList from "../components/ReorderableList";

export const PronosticarCategoria = ({
  conjuntos,
  setConjuntos,
  title,
  disabled = false,
  liguilla = 0,
  incluirEliminados = false,
  // M1-112 (revisión H-6): en la carga de resultados, la posición del acta.
  // El backend ordena por puntaje y solo la usa para desempatar dos puntajes
  // iguales.
  conPosicionActa = false
}) => {
  const renderItem = (item, i, { dragHandleProps }) => (
    <div
      className={`flex items-center gap-3 ${disabled ? "" : "item"} ${
        (liguilla && i + 1 > liguilla) ||
        (incluirEliminados && !item?.clasificadoLiguilla)
          ? "opaco"
          : ""
      }`}
      {...dragHandleProps}
    >
      {!liguilla && (
        <div className="w-auto text-start my-auto">
          <span>{i + 1}</span>
        </div>
      )}
      <div className="flex-1 text-center my-auto">{item?.nombre}</div>
      <TextField
        value={item?.puntosObtenidos}
        onChange={e => {
          setConjuntos(
            conjuntos.map(x => {
              if (x.id == item.id)
                return {
                  ...x,
                  // M1-112 (revisión H-6): sin truncar. Un puntaje con
                  // decimales no se redondea en silencio: Resultados.jsx
                  // avisa antes de guardar (la base guarda enteros).
                  puntosObtenidos: e.target.value === "" ? 0 : Number(e.target.value)
                };
              return x;
            })
          );
        }}
        type="number"
        inputProps={{ min: 0, step: 1 }}
        size="small"
        style={{ width: "120px" }}
      />
      {conPosicionActa && (
        <TextField
          value={item?.posicion ?? 0}
          label="Pos. acta"
          type="number"
          inputProps={{ min: 0, step: 1 }}
          onChange={e => {
            setConjuntos(
              conjuntos.map(x =>
                x.id == item.id
                  ? { ...x, posicion: e.target.value === "" ? 0 : Number(e.target.value) }
                  : x
              )
            );
          }}
          size="small"
          style={{ width: "80px" }}
        />
      )}
    </div>
  );

  return (
    <div className="text-center listado-conjunto-container">
      <h5>{title}</h5>
      <hr className="border-gray-200 dark:border-gray-700 my-4" />
      <div className="draggable-item">
        <ReorderableList
          items={conjuntos ?? []}
          getItemId={item => item.id}
          onChange={setConjuntos}
          disabled={disabled}
          reindexKey="posicion"
          renderItem={renderItem}
          renderSeparator={i =>
            i + 1 === liguilla && <hr className="separador-liguilla" />
          }
        />
      </div>
    </div>
  );
};

export default PronosticarCategoria;
